export default {
  get_AllBooking: [],
  selectBooking: {},
  user: {},
};
